import requestAction from '../../utils/requestAction'

export const fetchContacts = (params: string = "") =>
 requestAction('SCHOOL_CONTACT_LIST', params)(`school-contacts`, 'GET')
